<div class="card">
    <div class="card-header">
        Leave Form
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-2 px-1"><br>
                <label class="Label">Leave:</label>
            </div>
            <div class="col-md-4 px-1">
                &nbsp;&nbsp;<input name="Leavename" [(ngModel)]="LeaveName" type="text" class="form-control" readonly />
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Leave Type:</label>
            </div>
            <div class="col px-1">
                <label class="Label1 form-check-label link-dark px-1 text-label-light">
                    &nbsp; <input class="form-check-input" type="radio" name="Leavetype" value="Paid"
                        [(ngModel)]="LeaveType" (click)="onSelectionChange('LeaveType',$event)"> Paid
                </label>
                &nbsp;&nbsp;&nbsp; &nbsp;&nbsp; <label class="Label1 form-check-label link-dark px-1 text-label-light">
                    <input class="form-check-input" type="radio" name="Leavetype" value="Unpaid" [(ngModel)]="LeaveType"
                        (click)="onSelectionChange('LeaveType',$event)"> Unpaid
                </label>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Gender:</label>
            </div>
            <div class="col-md-5 px-1">
                <div class="col px-1">
                    <label class="Label1 form-check-label link-dark px-1 text-label-light">
                        <input class="form-check-input" type="radio" name="Gender" value="All" [(ngModel)]="Gender"
                            (click)="onSelectionChange('Gender',$event)"> All
                    </label>
                    &nbsp;&nbsp;&nbsp; &nbsp;&nbsp; <label
                        class="Label1 form-check-label link-dark px-1 text-label-light">
                        <input class="form-check-input" type="radio" name="Gender" value="Male" [(ngModel)]="Gender"
                            (click)="onSelectionChange('Gender',$event)"> Male
                    </label>
                    &nbsp;&nbsp;&nbsp; &nbsp;&nbsp; <label
                        class="Label1 form-check-label link-dark px-1 text-label-light">
                        <input class="form-check-input" type="radio" name="Gender" value="Female" [(ngModel)]="Gender"
                            (click)="onSelectionChange('Gender',$event)"> Female
                    </label>
                    &nbsp;&nbsp;&nbsp; &nbsp;&nbsp; <label
                        class="Label1 form-check-label link-dark px-1 text-label-light">
                        <input class="form-check-input" type="radio" name="Gender" value="Other" [(ngModel)]="Gender"
                            (click)="onSelectionChange('Gender',$event)"> Other
                    </label>
                </div>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Marital Status:</label>
            </div>
            <div class="col-md-4 px-1">
                <div class="col px-1">
                    <label class="Label1 form-check-label link-dark px-1 text-label-light">
                        <input class="form-check-input" type="radio" name="Maritalstatus" value="All"
                            [(ngModel)]="MaritalStatus" (click)="onSelectionChange('MaritalStatus',$event)"> All
                    </label>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <label
                        class="Label1 form-check-label link-dark px-1 text-label-light">
                        <input class="form-check-input" type="radio" name="Maritalstatus" value="Married"
                            [(ngModel)]="MaritalStatus" (click)="onSelectionChange('MaritalStatus',$event)"> Married
                    </label>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <label
                        class="Label1 form-check-label link-dark px-1 text-label-light">
                        <input class="form-check-input" type="radio" name="Maritalstatus" value="Unmarried"
                            [(ngModel)]="MaritalStatus" (click)="onSelectionChange('MaritalStatus',$event)"> Unmarried
                    </label>
                </div>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label" style="color: lightgray;">Comp Off</label>
            </div>
            <div class="col px-1">
                <label class="Label1 form-check-label link-dark px-1 text-label-light">
                    &nbsp; <input class="form-check-input" type="radio" name="Compoff" value="Yes" [(ngModel)]="CompOff"
                        disabled> Yes
                </label>
                &nbsp;&nbsp;&nbsp; &nbsp;&nbsp; <label class="Label1 form-check-label link-dark px-1 text-label-light">
                    <input class="form-check-input" type="radio" name="Compoff" value="No" [(ngModel)]="CompOff"
                        disabled> No
                </label>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="close()"><i
                    class="bi bi-x"></i> Cancel</button>

            <button *ngIf="this.common.PageRight.IsEdit" class="btn btn-sm btn-primary" name="save" (click)="save()"><i
                    class="bi bi-save"> </i> Save
            </button>
        </div>
    </div>
</div>